/**
 * サブステップ担当者 multi-select の「指定なし」排他ロジック (spec AC-WFT-010d、
 * issue #4550 multi-select 化)。
 *
 * 「指定なし」 chip と実在 member chip は選択肢 UI 上で排他: 「指定なし」 を
 * 選択すると実 member 全員の選択が自動解除され、 逆に実 member を追加選択す
 * ると「指定なし」 が自動解除される。 backend / DB は「指定なし」 を持たず、
 * assigneeMemberIds の空配列で「担当者なし」 を一意に表現する (Naming
 * convention 「指定なし」 semantics)。 呼び出し側 (SubStepEditor.tsx) は
 * unassignedSentinel を選択肢配列にのみ含め、 RHF の実 field 値には常に
 * sentinel を含めず渡す (= sentinel を含む戻り値は呼び出し側でフィルタする)。
 *
 * @param prev - 直前の選択状態 (unassignedSentinel を含みうる表示用配列)
 * @param next - MultiSelect が computed した選択後の配列 (直前状態 + 1 操作)
 * @param unassignedSentinel - 「指定なし」 を表す sentinel 値 (実 member_id と
 *   衝突しない専用文字列)
 * @returns 排他ルール適用後の選択配列 (unassignedSentinel を含みうる)
 */
export function toggleAssigneeSelection(
  prev: string[],
  next: string[],
  unassignedSentinel: string,
): string[] {
  const added = next.filter((v) => !prev.includes(v))
  const addedSentinel = added.includes(unassignedSentinel)
  const addedReal = added.some((v) => v !== unassignedSentinel)

  if (addedSentinel) {
    // 「指定なし」 が新たに選択された → 実 member 全解除、「指定なし」 のみ残す。
    return [unassignedSentinel]
  }
  if (addedReal) {
    // 実 member が新たに選択された → 「指定なし」 を自動解除。
    return next.filter((v) => v !== unassignedSentinel)
  }
  // 削除操作 (chip の × / 全解除) は追加が無いので排他ルールの対象外、
  // MultiSelect が computed した next をそのまま採用する。
  return next
}
